import { useMemo } from 'react';
import { useSelector } from 'react-redux';
// @ts-expect-error Untyped import
import { EVENTS } from '../../lib/usageTracker';
// @ts-expect-error Untyped import
import { trackEvent } from '../../lib/usageTracker';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Text } from 'foundations-components/components/Text';
import { dedupeSearchResults } from '../../utils/searchUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ShowMoreButton from '../../components/common/ShowMoreButton';
// @ts-expect-error Untyped import
import { selectSearchFilter } from '../../selectors/reportsSelector';
// @ts-expect-error Untyped import
import { selectTemplateGridData } from '../../selectors/templateGridData';
// @ts-expect-error Untyped import
import { selectAiSearchResponse } from '../../selectors/reportsSelector';
import { Table } from 'foundations-components/transitional/components/Table';
// @ts-expect-error Untyped import
import { selectGenerativeAIEnabled } from '../../selectors/aiSettingsSelector';
import ReadyMadeReportsTableRow from '../../components/fullscreenSearch/ReadyMadeReportsTableRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PREVIEW_LIMIT = 4;
const LIMIT = 10;
const ReadyMadeReportsContainer = ({
  showMore,
  setShowMore
}) => {
  const search = useSelector(selectSearchFilter);
  const reportTemplates = useSelector(selectTemplateGridData);
  const aiSearchResponse = useSelector(selectAiSearchResponse);
  const hasAiSearchSettingsEnabled = useSelector(selectGenerativeAIEnabled);
  const handleShowMoreClick = () => {
    trackEvent(EVENTS.clickShowMoreSearchResults, {
      filterValue: search,
      action: 'show-more-templates',
      subscreen: 'global-search'
    });
    setShowMore(true);
  };
  const filteredReportTemplates = useMemo(() => {
    return dedupeSearchResults(aiSearchResponse === null || aiSearchResponse === void 0 ? void 0 : aiSearchResponse.templateSuggestions, reportTemplates);
  }, [reportTemplates, aiSearchResponse === null || aiSearchResponse === void 0 ? void 0 : aiSearchResponse.templateSuggestions]);
  const templates = useMemo(() => {
    return showMore ? filteredReportTemplates.slice(0, LIMIT) : filteredReportTemplates.slice(0, PREVIEW_LIMIT);
  }, [filteredReportTemplates, showMore]);
  if (filteredReportTemplates.size === 0 && hasAiSearchSettingsEnabled) {
    return null;
  }
  const renderResults = () => {
    if ((filteredReportTemplates === null || filteredReportTemplates === void 0 ? void 0 : filteredReportTemplates.size) > 0) {
      return /*#__PURE__*/_jsxs(Table, {
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "reports.globalSearch.readyMadeReportsTable.nameColumn"
              })
            }), /*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "reports.globalSearch.readyMadeReportsTable.descriptionColumn"
              })
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: templates.map(template => /*#__PURE__*/_jsx(ReadyMadeReportsTableRow, {
            template: template
          }, template.get('templateKey')))
        })]
      });
    }
  };
  return /*#__PURE__*/_jsxs(Grid, {
    children: [hasAiSearchSettingsEnabled && /*#__PURE__*/_jsx(GridItem, {
      size: {
        xs: 12
      },
      marginBlockEnd: '500',
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.globalSearch.moreReadyMadeReports"
        })
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      size: {
        xs: 12
      },
      children: renderResults()
    }), (filteredReportTemplates === null || filteredReportTemplates === void 0 ? void 0 : filteredReportTemplates.size) > 3 && !showMore && /*#__PURE__*/_jsx(GridItem, {
      size: {
        xs: 12
      },
      children: /*#__PURE__*/_jsx(ShowMoreButton, {
        handleClickShowMoreButton: handleShowMoreClick,
        translationKey: "reports.globalSearch.seeAllReadyMade"
      })
    })]
  });
};
export default ReadyMadeReportsContainer;